import { useFragment, graphql } from 'react-relay';
import {
    useItemTranslations,
    INTERFACE_STATE,
} from '../PdpSharedOriginalLanguageProvider/PdpSharedOriginalLanguageProvider';
import {
    ITEM_IS_RING_RESIZABLE_ATTRIBUTE_ID,
    ITEM_IS_CUSTOMIZABLE_ATTRIBUTE_ID,
} from '../../constants/itemConstants';

// types
import { type useCustomizationOptions_item$key as Item } from './__generated__/useCustomizationOptions_item.graphql';

const itemFragment = graphql`
    fragment useCustomizationOptions_item on Item {
        attributes {
            customizable {
                option {
                    serviceId
                }
                text
            }
            ringResizable {
                option {
                    serviceId
                }
            }
        }
    }
`;

export const useCustomizationOptions = ({
    item: itemRef,
}: {
    item: Item;
}): {
    customizationOptions: string | null | undefined;
    isResizable: boolean;
} => {
    const item = useFragment(itemFragment, itemRef);
    const [state] = useItemTranslations();
    const itemAttributes =
        state?.interfaceState === INTERFACE_STATE.SHOW_ORIGINAL
            ? state?.data?.viewer?.item?.attributes
            : item?.attributes;
    const customizableAttrs = itemAttributes?.customizable || [];
    const regularCustomizable = customizableAttrs.find(
        customizableOption =>
            customizableOption?.option?.serviceId === ITEM_IS_CUSTOMIZABLE_ATTRIBUTE_ID
    );

    return {
        customizationOptions: regularCustomizable?.text,
        isResizable:
            itemAttributes?.ringResizable?.[0]?.option?.serviceId ===
            ITEM_IS_RING_RESIZABLE_ATTRIBUTE_ID,
    };
};
